'use strict';

const venmoList = require('./venmoList');
const venmoHelper = require('../helpers/venmoHelper');
const venmoSessionAccount = require('./venmoSessionAccount');
const helper = require('../../helper');

const braintreeVenmoNonceEl = document.getElementById('braintreeVenmoNonce');
const braintreeVenmoUserIdEl = document.getElementById('braintreeVenmoUserId');
const venmoBillingInputEl = document.getElementById('braintreeVenmoBilling');
const venmoContentEl = document.querySelector('.js-braintree-venmo-content');
const venmoButtonEl = document.querySelector('.js-braintree-venmo-button');
const continueButtonEl = document.querySelector('button.submit-payment');
const submitShippingBtnEl = document.querySelector('.button, .submit-shipping');
const saveBillingAddressCheckboxEl = document.getElementById('saveVenmoBillingAddress');

const dataAttrIsValidStage = 'data-is-valid-stage';

let hashChange;

/**
 * Process Venmo on the Billing/Checkout Page
 * @param {Object} data tokenized Venmo payload data
 */
function processCheckoutFlow(data) {
    const payerInfo = data.details.payerInfo;

    braintreeVenmoNonceEl.value = data.nonce;
    braintreeVenmoUserIdEl.value = data.details.username;

    let billingAddress;

    if (payerInfo.billingAddress) {
        billingAddress = venmoHelper.createBillingAddress(payerInfo);

        venmoBillingInputEl.value = JSON.stringify(billingAddress);
    } else {
        const address = require('base/checkout/address');

        const shippingForm = document.querySelector('.card-body [id=dwfrm_shipping]');

        billingAddress = address.methods.getAddressFieldsFromUI(shippingForm);
    }

    helper.updateStorefrontBillingData(billingAddress);

    // In case when stage is correct we proceed with usual flow
    if (window.history.state !== 'shipping') {
        continueButtonEl.click();

        return;
    }

    // In case when Venmo has returned from Venmo app to NOT correct stage (for example, to shipping stage)
    // we redirect user to correct stage and set required data
    const paymentMethodGeneralHelper = require('../../paymentMethodGeneralHelper');

    paymentMethodGeneralHelper.updateBillingAddressFormValues(helper.tryParseJSON(venmoBillingInputEl.value));
    // Move to stage payment
    submitShippingBtnEl.click();
    venmoButtonEl.setAttribute(dataAttrIsValidStage, true);
}

/**
 * Inits Venmo checkout components
 * @param {string} pageFlow - Page flow
 */
async function init(pageFlow) {
    const venmoBillingAddressHelper = require('../helpers/billingAddress');

    // MutationObserver is triggered on each URL change to avoid conflict between URL passed to Venmo application
    // and URL with already changed stage on storefront (checkout stage)
    // case when user is redirected from Venmo application
    hashChange = new MutationObserver(function(mutations) {
        let result = false;

        const mutation = mutations.find(function(element) {
            return element.attributeName === 'data-checkout-stage'
                && ['payment', 'shipping', 'customer'].includes(element.target.dataset.checkoutStage);
        });

        if (!mutation) {
            return result;
        }

        if (braintreeVenmoNonceEl.value && helper.tryParseJSON(venmoButtonEl.getAttribute(dataAttrIsValidStage))) {
            venmoButtonEl.setAttribute(dataAttrIsValidStage, false);
            continueButtonEl.click();

            result = true;

            return result;
        }

        const isVenmoPaymentActive = venmoContentEl.classList.contains('active');
        const isSessionAccountUsed = Boolean(window.braintreePreferences.isSessionPaymentsEnabled && braintreeVenmoNonceEl.value);

        // Case when user has proceeded with Venmo session account and clicked on "edit" button
        if (isVenmoPaymentActive && isSessionAccountUsed && ['placeOrder', 'shipping'].includes(mutation.oldValue)) {
            venmoSessionAccount.showVenmoSessionAccount();
        }

        return result;
    });

    hashChange.observe(document.getElementById('checkout-main'), { attributeOldValue: true });

    // Renders Venmo mark
    window.paypalVenmo.Marks({
        fundingSource: window.paypalVenmo.FUNDING.VENMO
    }).render('.js-venmo-tab');

    // Venmo button functionality is initiated once in case if it was not inited yet
    // based on existence of window.venmoCheckoutButtonInitted (set while Venmo button initiation)
    if (!window.venmoCheckoutButtonInitted) {
        window.venmoCheckoutButtonInitted = true;

        const VenmoBase = require('../models/venmoBase');
        const venmoBaseInstance = new VenmoBase(pageFlow);

        await venmoBaseInstance.initButton();

        venmoList.init();
    }

    const sessionPaymentMethodId = helper.tryParseJSON(venmoContentEl.getAttribute('data-braintree-config')).sessionPaymentMethodId;

    // if exists Venmo session account - we make Venmo tab active on page reload
    if (sessionPaymentMethodId === 'Venmo') {
        document.querySelector('.venmo-tab').click();

        if (window.braintreePreferences.isSessionPaymentsEnabled && braintreeVenmoNonceEl.value) {
            venmoSessionAccount.showVenmoSessionAccount();
        }
    }

    saveBillingAddressCheckboxEl?.addEventListener('change', venmoBillingAddressHelper.onSaveBillingAddressCheckboxChange);
}

module.exports = {
    init,
    processCheckoutFlow
};
